import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PcodeAds } from '../../typings/pcode';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { openConstructor } from '../AddCreativePage/actions';
import { CanvasAction } from '../common/actions';
import { Page } from '../common/typings';

import { changePage, hideBusy, showBusy } from './actions';
import { CanvasApp, CanvasAppProps } from './CanvasApp';

type OwnProps = {
    onClose: () => void;
    onCreativesSelect: (ids: number[]) => void;

    videoPreviewData?: PcodeAds;
};

type DispatchProps = TDispatchProps<CanvasAppProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>): DispatchProps => {
    return {
        showBusy: () => dispatch(showBusy()),
        hideBusy: () => dispatch(hideBusy()),
        changePage: (page: Page) => dispatch(changePage(page)),
        openConstructor: (page: Page) => dispatch(openConstructor(page))
    };
};

type StateProps = TStateProps<CanvasAppProps>;
export const mapStateToProps = (state: State): StateProps => {
    return {
        ...state.canvasEditor.canvas.commonData,
        sharedData: state.canvasEditor.sharedData
    };
};

export const CanvasAppContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(CanvasApp);
